import React, { Component } from "react";
import { CRUDFunction } from "../../reduxCURD/container";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import SvgIcon from "react-icons-kit";
import { languageService } from "../../Language/language.service";
import AssetDetail from "./AssetDetails/AssetDetails";
import { CommonTabs } from "../TabBarCompoenent/CommonTabs";
import { versionInfo } from "../MainPage/VersionInfo";
import MaintenanceHistory from "./MaintenanceHistory/MaintenanceHistory";
import OEMPage from "./OEM/OEMPage";
import SpinnerLoader from "../Common/SpinnerLoader";
import BlueCardViewTab from "./BlueCard";
import permissionCheck from "../../utils/permissionCheck";
import FieldsConfiguration from "./FieldsConfiguration";
import { isSuperAdminRole } from "../MainPage/UserInfo";
class AssetView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetDetail: null,
      selectedAsset: this.props.match ? this.props.match.params.id : null,
      selectedTab: this.props.match ? this.props.match.params.tab : "details",
      loader: true,
    };
    this.reFetchAsset = this.reFetchAsset.bind(this);
  }

  componentDidMount() {
    const { selectedAsset } = this.state;
    if (selectedAsset) this.props.getAssetViewData(`/${this.state.selectedAsset}`);
  }
  async reFetchAsset() {
    await this.props.getAssetViewData(`/${this.state.selectedAsset}`);
  }
  componentDidUpdate(prevProps) {
    if (this.props.actionType != prevProps.actionType && this.props.actionType === "ASSETVIEWDATA_READ_SUCCESS") {
      this.setState({ assetDetail: this.props.AssetViewData, loader: false });
    }
    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "ASSETVIEWDATA_READ_REQUEST") {
      this.setState({
        loader: true,
      });
    }
    if (this.props.actionType !== prevProps.actionType && this.props.actionType === "ASSETVIEWDATA_READ_FAILURE") {
      this.setState({
        loader: false,
      });
    }
  }
  render() {
    const getTabs = () => {
      const canViewFieldsConfig = permissionCheck("FIELD_CONFIGURATION", "fieldsconfig") || isSuperAdminRole();
      const common = [
        { id: "details", label: "Asset Details", order: 1 },
        ...(canViewFieldsConfig ? [{ id: "fieldsconfig", label: "Fields Configuration", order: 5 }] : []),
      ];

      const Locomotive = [
        { id: "history", label: languageService("Maintenance History"), order: 3 },
        { id: "oem", label: languageService("OEM"), order: 2 },
        ...(permissionCheck("BLUECARD", "initialize")
          ? [{ id: "blueCard", label: languageService("Initialize Blue Card"), order: 4 }]
          : []),
      ];

      let finalTabs = versionInfo.isReVAMP() ? [...common, ...Locomotive] : common;

      finalTabs.sort((a, b) => a.order - b.order);

      return finalTabs;
    };

    const { assetDetail, selectedTab, selectedAsset, loader } = this.state;
    const canViewFieldsConfig = permissionCheck("FIELD_CONFIGURATION", "fieldsconfig") || isSuperAdminRole();
    const activeTab = selectedTab === "fieldsconfig" && !canViewFieldsConfig ? "details" : selectedTab;
    return (
      <div>
        <div className="report-controls" style={{ width: "100%", padding: "15px" }}>
          <SpinnerLoader loading={this.state.loader} />{" "}
          <div style={{ display: "flex" }}>
            <div style={{ marginInlineEnd: "20px", cursor: "pointer" }} onClick={() => this.props.history.goBack()}>
              <SvgIcon icon={arrowLeft} size={20} />
            </div>
            <CommonTabs
              tabs={getTabs()}
              onTabChange={(tab) => {
                this.setState({ selectedTab: tab.id });
              }}
              selectedTab={activeTab}
            />
          </div>
        </div>

        {!loader && assetDetail && (activeTab == "details" || activeTab === undefined) && <AssetDetail selectedAsset={assetDetail} />}
        {!loader && assetDetail && activeTab == "oem" && <OEMPage selectedAsset={assetDetail} reFetchAsset={this.reFetchAsset} />}
        {!loader && assetDetail && activeTab == "history" && <MaintenanceHistory assetId={selectedAsset} selectedAsset={assetDetail} />}
        {!loader && assetDetail && activeTab == "blueCard" && (
          <BlueCardViewTab assetId={selectedAsset} selectedAsset={assetDetail} reFetchAsset={this.reFetchAsset} />
        )}
        {!loader && assetDetail && canViewFieldsConfig && activeTab == "fieldsconfig" && (
          <FieldsConfiguration selectedAsset={assetDetail} reFetchAsset={this.reFetchAsset} />
        )}
      </div>
    );
  }
}
// export default AssetView;

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
};

const AssetViewContainer = CRUDFunction(AssetView, "AssetViewData", actionOptions, null, null, "asset");

export default AssetViewContainer;



// WEBPACK FOOTER //
// ./src/components/AssetView/index.jsx